import { AddDriverCallPayload } from "../../utils/DriverCall/driverCallsApi";

export const ADD_DRIVER_CALL_REQUEST = "ADD_DRIVER_CALL_REQUEST";
export const ADD_DRIVER_CALL_SUCCESS = "ADD_DRIVER_CALL_SUCCESS";
export const ADD_DRIVER_CALL_FAILURE = "ADD_DRIVER_CALL_FAILURE";

export const GET_DRIVER_CALLS_REQUEST = "GET_DRIVER_CALLS_REQUEST";
export const GET_DRIVER_CALLS_SUCCESS = "GET_DRIVER_CALLS_SUCCESS";
export const GET_DRIVER_CALLS_FAILURE = "GET_DRIVER_CALLS_FAILURE";
export const CLEAR_DRIVER_CALL_STATUS = "CLEAR_DRIVER_CALL_STATUS";

export const addDriverCallRequest = (payload: AddDriverCallPayload) => ({
    type: ADD_DRIVER_CALL_REQUEST,
    payload,
});

export const addDriverCallSuccess = (message: string) => ({
    type: ADD_DRIVER_CALL_SUCCESS,
    payload: message,
});

export const addDriverCallFailure = (error: string) => ({
    type: ADD_DRIVER_CALL_FAILURE,
    payload: error,
});

export const clearDriverCallStatus = () => ({
    type: CLEAR_DRIVER_CALL_STATUS,
});

export const getDriverCallsRequest = (
    fromdate: string,
    todate: string,
    signal?: AbortSignal
) => ({
    type: GET_DRIVER_CALLS_REQUEST,
    payload: { fromdate, todate, signal },
});

export const getDriverCallsSuccess = (data: any[], total = data.length) => ({
    type: GET_DRIVER_CALLS_SUCCESS,
    payload: { data, total },
});

export const getDriverCallsFailure = (error: string) => ({
    type: GET_DRIVER_CALLS_FAILURE,
    payload: error,
});